export default __webpack_public_path__ + "static/media/hangout.09da1ba0.svg";